/** Gets the sort object from a delimited sort string. */
export function getSortObjectFromString(sortParam, sortKeys) {
    const [key, direction] = sortParam.split(':');
    const isValidKey = key && !!(sortKeys === null || sortKeys === void 0 ? void 0 : sortKeys.includes(key));
    const isValidDirection = typeof direction === 'undefined' ||
        (direction && (direction === 'asc' || direction === 'desc'));
    if (isValidKey) {
        return Object.assign({ key }, (isValidDirection ? { direction } : {}));
    }
}
